import { AutoComplete, Input, Tooltip, Breadcrumb } from "antd";
import { t } from "i18next";
import { AscRed, DeleteIcon, DescGrey, DetailIcon, EditIcon, PlusIcon, SearchIcon } from "../../../../asset";
import style from './skillSetPage.module.css'
import CustomTable from "../../../../component/table/CustomTable";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import SelectSearch from "../../../../component/input/SelectSearch";
import { useSkillset } from "./SkillsetPage.hooks";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';

export default function SkillSetList() {

    const {
        list,
        listDropdown,
        doDeleteSkillset,
        deleteConfirmation,
        deleteConfirmationModalOpen,
        setDeleteConfirmationModalOpen,
        selectedId,
        setSuccessModalOpen,
        successModalOpen,
        toEditSkillSet,
        toDetailSkillSet,
        toAddSkillset,
        options,
        onSearch,
        onSelect,
        doGetListSkillset,
        searchKeyword,
        selectDepotId,
        totalData,
        handlePagination,
        selectedDepotId,
        doSort,
        sorting,
        statePageSize,
        handleChangeLimit,
        doClear,
        currentPage,
        onScroll,
        onSearchDDS,
        dropdownListLoading,
        depotKeyword
    } = useSkillset();

    const SkillSetListColumn = [
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("SKILLSET:SKILLSET_ID_FIELD")}
                </span>
            ),
            dataIndex: 'skillSetId',
            key: 'skillSetId',
            render: (skillSetId) => <span>{skillSetId}</span>,
        },
        {
            title: (
                <div className="flex w-auto">
                    <span className="font-roboto text-lg font-[500] text-[#222222]">
                        {t("SKILLSET:SKILLSET_NAME_FIELD")}
                    </span>
                    <div style={{ marginLeft: "10px", marginTop: "3px" }}>
                        <div className={style.SortArea}>
                            <Tooltip title={t("Asc")} color="#CF0000">
                                <img
                                    src={sorting === "skillset_name asc" ? AscRed : DescGrey}
                                    alt="asc"
                                    className={sorting === "skillset_name asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("skillset_name asc")}
                                />
                            </Tooltip>

                            <Tooltip title={t("Desc")} color="#CF0000">
                                <img
                                    src={sorting === "skillset_name desc" ? AscRed : DescGrey}
                                    alt="desc"
                                    className={sorting === "skillset_name desc" ? "w-[10px] h-[10px] cursor-pointer rotate-180 " : "w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("skillset_name desc")}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            dataIndex: 'skillSetName',
            key: 'skillSetName',
            sortDirections: ['descend', 'ascend'],
            render: (skillSetName) => <span>{skillSetName}</span>,
        },
        {
            title: (
                <div className="flex w-auto">
                    <span className="font-roboto text-lg font-[500] text-[#222222]">
                        {t("SKILLSET:DESCRIPTION_FIELD")}
                    </span>
                </div>
            ),
            dataIndex: 'description',
            key: 'description',
            render: (description) => <span>{description}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg font-[500] text-[#222222]">
                    {t("SKILLSET:ACTION_FIELD")}
                </span>
            ),
            dataIndex: 'action',
            key: 'action',
            render: (action) => <span>{action}</span>,
        }
    ]

    const dataSource = list?.map((item) => ({
        skillSetId: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.skill_set_id}
            </span>
        ),
        skillSetName: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.skill_set_name}
            </span>
        ),
        description: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.description}
            </span>
        ),
        action: (
            <div className="flex gap-[26px]">
                <Tooltip title={t("SKILLSET:EDIT_TOOLTIP")} color="#CF0000">
                    <button>
                        <img src={EditIcon} onClick={() => toEditSkillSet(item)} />
                    </button>
                </Tooltip>
                <Tooltip title={t("SKILLSET:DELETE_TOOLTIP")} color="#CF0000">
                    <button>
                        <img src={DeleteIcon} onClick={() => deleteConfirmation(item.skill_set_id, item.updated_at)} />
                    </button>
                </Tooltip>
                <Tooltip title={t("SKILLSET:DETAIL_TOOLTIP")} color="#CF0000">
                    <button >
                        <img src={DetailIcon} onClick={() => toDetailSkillSet(item.skill_set_id)} />
                    </button>
                </Tooltip>
            </div>
        )
    }))

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <DeleteConfirmationModal
                isOpen={deleteConfirmationModalOpen}
                onOk={() => setDeleteConfirmationModalOpen(false)}
                onCancel={() => doDeleteSkillset()}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Cancel"
                cancelText="Yes, Delete"
                title="Delete Data?"
                description={<p>Are you Sure want to delete <strong>Skillset ID {selectedId}</strong>?</p>}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => setSuccessModalOpen(false)}
                closable={false}
                width={280}
                className={style.deleteModal}
                okText="Ok"
                title="Success"
                description="Your data has been deleted"
            />

            <Breadcumbs
                jmlLevel={3}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Skillset`}
            />

            <h1 className='font-sans-bold text-2xl' id='title'>{t("SKILLSET:TITLE")}</h1>

            <div className={style.headerContainer + ' flex justify-between items-center'}>
                <div className="flex gap-[16px]">
                    <AutoComplete
                        options={options}
                        onSelect={onSelect}
                        allowClear={true}
                        onClear={() => doClear(selectedDepotId)}
                    // suffixIcon={<img src={SearchIcon} />}
                    >
                        <Input
                            placeholder={"Search Name"}
                            height={47}
                            onChange={(event) => onSearch(event)}
                            suffix={<img src={!searchKeyword ? SearchIcon : null} />}
                            style={{ fontSize: "20px" }}
                        />
                    </AutoComplete>

                    {
                        listDropdown?.length !== 0 ?

                            <SelectSearch onScroll={(event) => onScroll(event, 'depotList')} keyword={depotKeyword} onChange={(value) => onSearchDDS(value, 'depotList')} onSelect={(value) => selectDepotId(value, 1, 10)} width={292} options={listDropdown} loading={dropdownListLoading} defaultValue={listDropdown[0].value} />

                            :

                            null
                    }
                </div>

                <PrimaryButton text={t("SKILLSET:ADD_SKILLSET_BUTTON")} prefixIcon={<img src={PlusIcon} />} action={toAddSkillset} />

            </div>

            <div className={style.tableContainer}>

                <CustomTable currentPage={currentPage} columns={SkillSetListColumn} data={dataSource} pageLimit={statePageSize} onChange={(page, pageSize) => handleChangeLimit(page, pageSize, selectedDepotId)} total={totalData} showPagination />

            </div>
        </div>
    );
}